import React, { useState } from "react";

const SubscribeSection = () => {
  // State to handle input value (Simple React State)
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thanks! We will send updates to: ${email}`);
    setEmail("");
  };

  return (
    <section className="py-24 bg-gradient-to-br from-blue-700 to-indigo-900 text-white relative overflow-hidden">
      {/* Decorative Abstract Circles */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-400 opacity-10 rounded-full blur-2xl -translate-x-1/2 translate-y-1/2"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center">
        {/* --- Section Header --- */}
        <h2 className="text-3xl md:text-5xl font-bold mb-6">
          Stay Ahead of the Curve
        </h2>
        <p className="text-lg text-blue-100 mb-12 max-w-2xl mx-auto">
          Get the latest insights on software development, design trends, and
          company news delivered straight to your inbox. No spam, just value.
        </p>

        {/* --- Subscription Form --- */}
        <form
          onSubmit={handleSubmit}
          className="max-w-xl mx-auto bg-white/10 backdrop-blur-md p-2 rounded-2xl border border-white/20 shadow-2xl flex flex-col sm:flex-row gap-2"
        >
          {/* Email Input */}
          <input
            type="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 bg-transparent text-white placeholder-blue-200 px-6 py-4 outline-none rounded-xl sm:rounded-none sm:rounded-l-xl focus:bg-white/10 transition-colors"
            required
          />

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-4 bg-white text-indigo-900 font-bold rounded-xl sm:rounded-none sm:rounded-r-xl hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl transform active:scale-95"
          >
            Subscribe Now
          </button>
        </form>

        {/* Trust Message */}
        <div className="mt-8 flex items-center justify-center gap-2 text-sm text-blue-200">
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>Join 5,000+ subscribers</span>
        </div>
      </div>
    </section>
  );
};

export default SubscribeSection;
